import { createSelector } from '@reduxjs/toolkit';
import { selectOfferType } from './selectOfferType';
import { isHotel } from 'shared/utils/jsonQuery';

export const selectIsHotelSearch = createSelector(selectOfferType, isHotel);
